import React from "react";
import {
  FaUserAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaBuilding,
  FaMapMarkerAlt,
  FaMoneyBillWave,
  FaCalendarAlt,
  FaCommentDots,
  FaUserTie,
} from "react-icons/fa";
import AppModal from "./AppModal";

const ShowLeadModal = ({ showView, setShowView, selectedLead }) => {
  return (
    <AppModal
      show={showView}
      setShow={setShowView}
      title="Lead Details"
      size="modal-lg"
      footer={
        <>
          <button className="btn btn-danger" onClick={() => setShowView(false)}>
            Close
          </button>
        </>
      }
    >
      <div className="row gy-1">
        {/* Left Section */}
        <div className="col-lg-6">
          <div className="card border-0 shadow-sm rounded-4 h-100">
            <div className="card-body">
              <h5 className="fw-bold mb-2">Customer Information</h5>

              <div className="lead-detail-item">
                <FaUserAlt className="icon text-primary" />

                <div>
                  <span>Customer Name</span>
                  <h6>{selectedLead?.name || "N/A"}</h6>
                </div>
              </div>

              <div className="lead-detail-item">
                <FaPhoneAlt className="icon text-success" />

                <div>
                  <span>Mobile Number</span>
                  <h6>{selectedLead?.mobile || "N/A"}</h6>
                </div>
              </div>

              <div className="lead-detail-item">
                <FaEnvelope className="icon text-danger" />

                <div>
                  <span>Email Address</span>
                  <h6>{selectedLead?.email || "demo@gmail.com"}</h6>
                </div>
              </div>

              <div className="lead-detail-item">
                <FaBuilding className="icon text-warning" />

                <div>
                  <span>Company Name</span>
                  <h6>{selectedLead?.company || "A2 Technosoft"}</h6>
                </div>
              </div>

              <div className="lead-detail-item">
                <FaMapMarkerAlt className="icon text-info" />

                <div>
                  <span>Address</span>
                  <h6>{selectedLead?.address || "Jaipur, Rajasthan"}</h6>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="col-lg-6">
          <div className="card border-0 shadow-sm rounded-4 h-100">
            <div className="card-body p-4">
              <h5 className="fw-bold mb-3">Lead Information</h5>

              <div className="lead-detail-item">
                <FaUserTie className="icon text-secondary" />

                <div>
                  <span>Assigned User</span>
                  <h6>{selectedLead?.assigned || "Rahul"}</h6>
                </div>
              </div>

              <div className="lead-detail-item">
                <FaCalendarAlt className="icon text-primary" />

                <div>
                  <span>Follow-Up Date</span>
                  <h6>15 May 2026</h6>
                </div>
              </div>

              <div className="lead-detail-item">
                <FaMoneyBillWave className="icon text-success" />

                <div>
                  <span>Estimate Amount</span>
                  <h6>₹ 25,000</h6>
                </div>
              </div>

              <div className="mb-4 d-flex align-items-center gap-4">
                <span className="d-block text-muted">Lead Status</span>

                <span className="badge bg-success px-3 py-2 fs-6 rounded-pill">
                  {selectedLead?.status || "New"}
                </span>
              </div>

              <div className="mb-4 d-flex align-items-center gap-4">
                <span className="d-block text-muted">Lead Source</span>

                <span className="badge bg-primary px-3 py-2 fs-6 rounded-pill">
                  {selectedLead?.source || "Facebook"}
                </span>
              </div>

              <div>
                <span className="d-block text-muted mb-2">Comment</span>

                <div className="comment-box">
                  <FaCommentDots className="me-2 text-secondary" />
                  Interested in website & mobile app development.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppModal>
  );
};

export default ShowLeadModal;
